import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import pl from 'vuetify/es5/locale/pl';
import '@fortawesome/fontawesome-free/css/all.css'
import store from "@/store";
Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: {pl},
        current: 'pl',
    },
    icons: {
        iconfont: 'fa',
        values: {
            android: 'fab fa-android',
            apple: 'fab fa-apple'
        }
    },
    theme: {
        dark: store.getters.isDark
    }
});
